var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.36328H3.75C3.33579 3.36328 3 3.69907 3 4.11328V20.6133C3 21.0275 3.33579 21.3633 3.75 21.3633H20.25C20.6642 21.3633 21 21.0275 21 20.6133V4.11328C21 3.69907 20.6642 3.36328 20.25 3.36328Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.8633V16.8633",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.8633V16.8633",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.4883C11.25 12.7921 11.5266 12.1244 12.0188 11.6321C12.5111 11.1398 13.1788 10.8633 13.875 10.8633C14.5712 10.8633 15.2389 11.1398 15.7312 11.6321C16.2234 12.1244 16.5 12.7921 16.5 13.4883V16.8633",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.36328C8.87132 9.36328 9.375 8.8596 9.375 8.23828C9.375 7.61696 8.87132 7.11328 8.25 7.11328C7.62868 7.11328 7.125 7.61696 7.125 8.23828C7.125 8.8596 7.62868 9.36328 8.25 9.36328Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.363281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.ce89f8ad3b2e4e711934ac4dffe24656.svg";
export { ForwardRef as ReactComponent };